import {
  faEdit,
  faPlusCircle,
  faImage,
  faCamera,
  faSave,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Modal from "../common/Modal";
import { useForm } from "react-hook-form";
import { SaveSample, SaveBatchEditHistory } from "../../services/BatchService";
import Webcam from "react-webcam";
import { NotificationManager } from "react-notifications";

export default function SampleRow({
  Sample,
  onChecked,
  isSelected,
  handleImport,
  handleDelete,
  LoadData,
}) {
  const [readonly, setReadOnly] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSampleFail, setIsSampleFail] = useState(false);

  useEffect(() => {
    if (isSelected === true && !readonly) uncheck();
  }, [isSelected, readonly, Sample.imageBase64]);

  useEffect(() => {
    if (
      (Sample.coliform !== null && Sample.coliform === true) ||
      (Sample.hpc !== null && Sample.hpc > 200)
    ) {
      setIsSampleFail(true);
    } else if (Sample.hpc !== null && Sample.hpc === ">738") {
      setIsSampleFail(true);
    } else if (
      Sample.type === "Ecoli" &&
      (Sample.result > 235 || Sample.result === ">2419.6")
    ) {
      setIsSampleFail(true);
    }
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { isDirty },
  } = useForm({
    defaultValues: Sample,
  });

  if (!Sample) return <></>;

  const uncheck = () => {
    onChecked(Sample.id, false);
  };

  const handleCheckboxClick = (e) => {
    onChecked(Sample.id, e.target.checked);
  };

  const handleEditClick = () => {
    let currValue = readonly;
    setReadOnly(!readonly);
    if (currValue === false) reset(Sample);
    if (currValue === true && isSelected) uncheck();
  };
  const onAddImage = () => {
    SaveSample(Sample);
    setModalOpen(true);
    reset(Sample);
    NotificationManager.success("New image added");
  };

  const onRemoveImage = () => {
    Sample.imageBase64 = null;
    SaveSample(Sample);
    Sample.imageBase64 = null;
    setModalOpen(true);
    reset(Sample);
    NotificationManager.success("Image removed");
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageSrc = reader.result;
        Sample.imageBase64 = imageSrc;
        onAddImage();
      };
      reader.readAsDataURL(file);
    }
  };

  const SaveSampleEditHistory = async (data, originalData) => {
    const changes = [];
    const formatDate = (date) => {
      const d = new Date(date);
      return `${d.toLocaleDateString()} at ${d.toLocaleTimeString()}`;
    };

    const addHistory = (sampleId, field, oldValue, newValue) => {
      if (oldValue !== newValue) {
        changes.push(
          `Sample ${sampleId}: ${field} changed from "${oldValue}" to "${newValue}"`
        );
      }
    };

    // Compare properties and add changes to the history
    addHistory(
      data.sampleLabId,
      "Coliform",
      originalData.coliform,
      data.coliform
    );

    addHistory(data.sampleLabId, "Ecoli", originalData.ecoli, data.ecoli);
    addHistory(data.sampleLabId, "HPC", originalData.hpc, data.hpc);
    addHistory(
      data.sampleLabId,
      "Image",
      originalData.imageBase64 ? "present" : "absent",
      data.imageBase64 ? "present" : "absent"
    );
    addHistory(data.sampleLabId, "Result", originalData.result, data.result);
    addHistory(
      data.sampleLabId,
      "Sample Lab Id",
      originalData.sampleLabId,
      data.sampleLabId
    );
    try {
      if (changes.length > 0) {
        const loggedInUser = JSON.parse(
          localStorage.getItem("loggedInUser")
        ).operator;
        const timestamp = new Date().toLocaleString();
        const historyEntry = changes
          .map((change) => `${change} by ${loggedInUser} on ${timestamp}`)
          .join("___");

        var response = await SaveBatchEditHistory({
          batchId: data.batchId,
          batchEditHistory: "__+++ At Batch Manager : " + historyEntry,
        });

        if (response.status === 200) {
          NotificationManager.success("Changes saved", "Success!");
        }
      }
    } catch (err) {
      NotificationManager.error(err.toString(), "Error Submitting");
    } finally {
      LoadData();
    }
  };

  const handleSave = () => {
    try {
      handleSubmit(async (data) => {
        const resp = await SaveSample(data);
        if (resp.status === 200) {
          SaveSampleEditHistory(data, Sample);
          let updatedModel = resp.json();
          reset(updatedModel);
          setReadOnly(true);
        }
      })();
    } catch (err) {
      NotificationManager.error(err.toString(), "Error Submitting");
    }
  };

  return (
    <tr style={{ backgroundColor: !readonly ? "#FFF5DA" : "transparent" }}>
      <td
        style={{ minWidth: "150px", width: "150px" }}
        className=" is-vcentered"
      >
        <div className="columns">
          <div className="column is-3">
            <input
              type="checkbox"
              className="checkbox"
              checked={isSelected}
              onChange={handleCheckboxClick}
            />
          </div>
          <div className="column">
            <button
              type="button"
              className="button is-small mr-1"
              onClick={handleEditClick}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>
            <button
              type="button"
              className={
                "button is-small is-success " + (!isDirty && " is-hidden")
              }
              onClick={handleSave}
            >
              <FontAwesomeIcon icon={faSave} />
            </button>
          </div>
        </div>
      </td>
      <td className="has-text-centered is-vcentered"></td>
      <td className="has-text-centered is-vcentered"></td>
      <td className="has-text-centered is-vcentered">
        <input
          type="text"
          className={`input ${isSampleFail ? "is-danger" : ""}`}
          {...register("sampleLabId")}
          readOnly={readonly}
        />
      </td>
      <td className="has-text-centered is-vcentered">
        {/* <label className="">{FormatOutDate(Sample.outTime)}</label> */}
      </td>
      <td className="has-text-centered is-vcentered">
        {/* <label className="">{Sample.outUser}</label> */}
      </td>
      <td className="px-3 has-items-centered">
        <td className="has-text-centered is-vcentered px-6">
          {Sample.coliform !== null &&
            Sample.type.includes("TC") &&
            !readonly && (
              <input
                type="checkbox"
                className={`${isSampleFail ? "is-danger" : ""}`}
                defaultChecked={false}
                {...register("coliform")}
              />
            )}
          {Sample.coliform !== null &&
            Sample.type.includes("TC") &&
            readonly && (
              <input
                type="checkbox"
                className={`${isSampleFail ? "is-danger" : ""}`}
                defaultChecked={false}
                checked={Sample.coliform}
              />
            )}
        </td>
        <td className="has-text-centered is-vcentered px-6">
          {Sample.ecoli !== null && Sample.type.includes("TC") && !readonly && (
            <input
              type="checkbox"
              defaultChecked={false}
              {...register("ecoli")}
            />
          )}
          {Sample.ecoli !== null && Sample.type.includes("TC") && readonly && (
            <input
              type="checkbox"
              defaultChecked={false}
              checked={Sample.ecoli}
            />
          )}
        </td>
      </td>
      <td className="has-text-centered  is-vcentered is-centered">
        {Sample.hpc !== null && Sample.type.includes("HPC") && (
          <input
            type="textbox"
            className={`input ${isSampleFail ? "is-danger" : ""}`}
            {...register("hpc")}
            readOnly={readonly}
          />
        )}
        {Sample.result !== null && (
          <input
            type="textbox"
            className={`input ${isSampleFail ? "is-danger" : ""}`}
            {...register("result")}
            readOnly={readonly}
            placeholder="<1"
          />
        )}
      </td>
      <td>
        <td className="has-text-centered">
          <Modal
            closeModal={() => setModalOpen((curr) => !curr)}
            isOpen={modalOpen}
            title={Sample.sampleLabId}
          >
            <div className="columns">
              <div className="column">
                <textarea
                  className="input"
                  rows={10}
                  style={{ minHeight: "100px" }}
                  {...register("comments")}
                  readOnly={readonly}
                ></textarea>
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <input type="text" hidden />
                {Sample.imageBase64 !== null ? (
                  <>
                    <img src={Sample.imageBase64} />
                    <div className="has-text-right">
                      <button
                        type="button"
                        onClick={() => {
                          onRemoveImage();
                        }}
                        className="button is-warning"
                      >
                        <FontAwesomeIcon icon={faImage} />
                        &nbsp; Remove
                      </button>
                    </div>
                  </>
                ) : (
                  <Webcam
                    audio={false}
                    height={720}
                    screenshotFormat="image/jpeg"
                    width={1280}
                    videoConstraints={{
                      width: 1280,
                      height: 720,
                      facingMode: "environment",
                    }}
                  >
                    {({ getScreenshot }) => (
                      <div className="has-text-right">
                        <button
                          onClick={() => {
                            const imageSrc = getScreenshot();
                            Sample.imageBase64 = imageSrc;
                            onAddImage();
                          }}
                          type="button"
                          className="button is-primary is-right"
                        >
                          Take{" "}
                          <FontAwesomeIcon
                            style={{ marginLeft: "5px" }}
                            icon={faCamera}
                          />
                        </button>
                        <button
                          type="button"
                          className="button is-primary is-right"
                          style={{ marginLeft: "10px" }}
                          onClick={() => {
                            const fileInput = document.createElement("input");
                            fileInput.type = "file";
                            fileInput.accept = "image/*";
                            fileInput.onchange = handleImageUpload;
                            fileInput.click();
                          }}
                        >
                          Attach
                          <FontAwesomeIcon
                            style={{ marginLeft: "5px" }}
                            icon={faPaperclip}
                          />
                        </button>
                      </div>
                    )}
                  </Webcam>
                )}
              </div>
            </div>
          </Modal>
          <button
            type="button"
            className={
              "button " +
              (getValues("comments") || getValues("imageBase64")
                ? "is-link"
                : "is-info")
            }
            onClick={() => setModalOpen((curr) => !curr)}
          >
            <FontAwesomeIcon icon={faPlusCircle} />
          </button>
        </td>

        <td>
          <button
            className="button is-danger"
            onClick={() => handleDelete(Sample.id)}
          >
            X
          </button>{" "}
        </td>
      </td>
      <td>
        <button
          className={`button px-5 ${isSampleFail ? "is-danger" : ""}`}
          onClick={() => handleImport(Sample.id)}
          disabled={isDirty || !Sample.reviewed}
        >
          Import
        </button>
      </td>
    </tr>
  );
}
